export const AreaTypesIdData = {
    GET_AllAreaIdUser: "GET_AllQRCodeIdUser",
    
}